import React from "react";

import { inject, observer } from "mobx-react";

import logo from './img/header_logo.webp'

import "./style.scss";


const Hearer = inject("mainStore")(observer(({ mainStore }) => {

    return (
        <div className={`header`}>
            <div className="header__block">
                <img src={logo} className="header__logo"/>
                <span className="block__title">Лучшие спецпредложения от банков</span>
                <span className="block__description_mobile">у вас есть 5 минут</span>
            </div>
        </div>
    );
}));

export default Hearer;
